// AUTO-GENERATED by scripts/prepare-brand.mjs for NEXT_PUBLIC_BRAND=skufvpn — do not edit
export { default as brand } from './brands/skufvpn'
